import React, { useContext}from "react";
import useForm from 'react-hook-form';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import "beaktShared/components/CustomInput/rotate.css";
import { SessionContext } from "beaktShared/services/session";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { UsePutApi } from "beaktShared/services/crudeApiService";
const useStyles = makeStyles(styles);

export default function RedefinirSenha() {
  const session = useContext(SessionContext);
    
  const classes = useStyles();
  const { register, handleSubmit, errors, setError } = useForm({mode: "onBlur"});
  const [loading, setLoading] = React.useState(false);

  const [messageg, setmessageg] = React.useState({
    exist: false,
    message: "",
    type: "error"
   });
  
  const handleshowMessage = (exist,message,type) =>{
    setmessageg({
      exist: exist,
      message: message,
      type: type
    });
  }


    const onSubmit = (data)=> {
  
    handleshowMessage(false,'','');
    setLoading(true);
            
    setLoading(false);  
    if(data.definasenha==="")        
    return setError("definasenha", "required")
    
    if(data.confirmasenha==="")        
    return setError("confirmasenha", "required")
    
    if(!(data.definasenha===data.confirmasenha))      
    {
        handleshowMessage(true, "Nova Senha e Confirmar Senha devem ser iguais!", 'error')
        return;
    }  

    var obj = {   
    login: session.login,
    password: data.definasenha
    }

    setLoading(true);
    let endPoint = 'usuarios/alterpassword';
    UsePutApi(endPoint, '', obj).then(result=>{      
    if(result.status !== 200)
    {
        handleshowMessage(true, result.message,'error') 
        setLoading(false);
        return false;
    }

    
    setLoading(false);        
    handleshowMessage(true, "Senha atualizada com sucesso!", 'success')
    return true;
    });

    return;        
    
    };

return (
    <form onSubmit={handleSubmit(onSubmit)}>
    <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth className={classes.formControl}>                               
            <TextField  
                label="Defina Nova Senha *"    
                variant="outlined"          
                error={errors.definasenha?true:false}
                inputRef={register({required: true})}
                name="definasenha"
                type="password"
                InputProps={{
                    autoComplete: "off"
                }}
                inputProps={{ maxLength: 10}}
            /> 
            <FormHelperText className={classes.labelRootError}>
                {errors.definasenha && <span> Obrigatório </span>}
            </FormHelperText>
        </FormControl> 
        
        <FormControl fullWidth className={classes.formControl}>                               
            <TextField  
                label="Confirmar Nova Senha *"  
                variant="outlined"
                error={errors.confirmasenha?true:false}
                inputRef={register({required: true})}
                name="confirmasenha"
                type="password"
                InputProps={{
                autoComplete: "off"
                }}
                inputProps={{ maxLength: 10}}
            /> 
            <FormHelperText className={classes.labelRootError}>
                {errors.confirmasenha && <span> Obrigatório </span>}
            </FormHelperText>
        </FormControl> 

        
        {messageg.exist &&<b className={messageg.type==='error' ? classes.labelRootError : classes.labelRootSuccess}>
                <span> {messageg.message} </span>
        </b> 
        }

        </GridItem>
        </GridContainer>
        <Button type="submit" color="primary" className={classes.updateProfileButton}>
        Atualizar
        {loading && <div> ... CARREGANDO</div>}
        </Button>
        <Clearfix />
        </form>
)

}